<template>
<!-- Footer -->
    <footer>
        <div class="container">
            <p>&copy; 2025 SivaJyothirmayi P. All rights reserved.</p>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>

<style scoped>

</style>
